import moment from 'moment';
import * as Yup from 'yup';

export const uniqueBalanceIds = array => {
  const balanceIds = array.map(item => item.balanceId);
  return new Set(balanceIds).size === balanceIds.length;
};

const validationSchema = () => {
  return Yup.object().shape({
    employee: Yup.object().shape({
      id: Yup.string().required('Debes seleccionar el empleado')
    }),
    endDate: Yup.string()
      .required('Debes especificar una fecha de término')
      .test('endDate', 'La fecha de término no puede ser menor a la fecha de inicio', function(value) {
        const startDate = moment(this.parent?.employee?.startDate, 'DD/MM/YYYY');
        const endDate = moment(value, 'DD/MM/YYYY');
        return endDate.isAfter(startDate);
      }),
    issueDate: Yup.string()
      .required('Debes especificar una fecha de emisión')
      .test('issueDate', 'La fecha de emisión debe ser mayor o igual a la fecha de término', function(value) {
        const issueDate = moment(value, 'DD/MM/YYYY');
        const endDate = moment(this.parent?.endDate, 'DD/MM/YYYY');
        return issueDate.isSameOrAfter(endDate);
      }),
    terminationReason: Yup.number().required('Debes seleccionar un motivo de término'),
    justificationTerminationReason: Yup.string()
      .nullable()
      .max(250, 'La justificación debe tener un máximo de 250 caracteres')
  });
};

export default validationSchema;
